<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Módulo Variables de Procesador de Pagos:</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <vs-card>
            <template slot="header">
              <div class="flex">
                <h2 class="flex-1">Variables de Procesador de Pagos</h2>
                <vs-button icon="add" @click="editVar='New'"></vs-button>
              </div>
            </template>

              <vs-table :data="[{}]">
                <template slot="thead">
                  <vs-th>ID</vs-th>
                  <vs-th>Variable BT</vs-th>
                  <vs-th>Información</vs-th>
                  <vs-th>Banco/Procesador</vs-th>
                  <vs-th style="text-align: center">Editar | Borrar</vs-th>
                </template>
                <vs-tr v-if="editVar==='New'">
                  <vs-td>{{editVar}}</vs-td>
                  <vs-td>
                    <vs-input label="Variable BT" v-model="bt_variable" maxlength="2"></vs-input>
                  </vs-td>
                  <vs-td>
                    <vs-textarea label="Información" v-model="bank_processor_name" maxlength="50"></vs-textarea>
                  </vs-td>
                  <vs-td>
                    <vs-select label="Procesador de Pago" v-model="payment_processor">
                      <vs-select-item text="OpenPay" value="openpay"></vs-select-item>
                      <vs-select-item text="STP" value="stp"></vs-select-item>
                      <vs-select-item text="Santander" value="santander"></vs-select-item>
                      <vs-select-item text="Banregio" value="banregio"></vs-select-item>
                      <vs-select-item text="BanBajio" value="banbajio"></vs-select-item>
                      <vs-select-item text="Conekta" value="conekta-oxxo-pay"></vs-select-item>
                      <vs-select-item text="HSBC" value="hsbc"></vs-select-item>
                    </vs-select>
                  </vs-td>
                  <vs-td style="width: 16%;text-align: center">
                    <div class="flex gap-2">
                      <vs-button color="secondary" class="text-dark" icon="save" v-on:click="guardarVar()">
                      </vs-button>
                      <vs-button color="danger" icon="clear" v-on:click="limpiar()">
                      </vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="variable in variables" :key="variable.id">
                  <vs-td>{{variable.id}}</vs-td>

                  <vs-td v-if="editVar===variable.id">
                    <vs-input label="Variable BT" v-model="bt_variable" maxlength="4"></vs-input>
                  </vs-td>
                  <vs-td v-else>{{variable.bt_variable}}</vs-td>

                  <vs-td v-if="editVar===variable.id">
                    <vs-textarea label="Información" v-model="bank_processor_name" maxlength="50"></vs-textarea>
                  </vs-td>
                  <vs-td v-else>{{variable.bank_processor_name}}</vs-td>

                  <vs-td v-if="editVar===variable.id">
                    <vs-select label="Procesador de Pago" v-model="payment_processor">
                      <vs-select-item text="OpenPay" value="openpay"></vs-select-item>
                      <vs-select-item text="STP" value="stp"></vs-select-item>
                      <vs-select-item text="Santander" value="santander"></vs-select-item>
                      <vs-select-item text="Banregio" value="banregio"></vs-select-item>
                      <vs-select-item text="BanBajio" value="banbajio"></vs-select-item>
                      <vs-select-item text="Conekta" value="conekta-oxxo-pay"></vs-select-item>
                      <vs-select-item text="HSBC" value="hsbc"></vs-select-item>
                    </vs-select>
                  </vs-td>
                  <vs-td v-else>{{variable.payment_processor}}</vs-td>

                  <vs-td v-if="editVar===variable.id">
                    <div class="flex gap-2">
                      <vs-button color="secondary" class="text-dark" icon="save" v-on:click="guardarVar()">
                      </vs-button>
                      <vs-button color="danger" icon="clear" v-on:click="limpiar()">
                      </vs-button>
                    </div>
                  </vs-td>
                  <vs-td v-else>
                    <div class="flex gap-2">
                      <vs-button color="secondary" class="text-dark" icon="edit" v-on:click="editarVar(variable)">
                      </vs-button>
                      <vs-button color="danger" icon="delete" v-on:click="borrarVar(variable.id)">
                      </vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </vs-table>
          </vs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

  export default  {
    name: 'payment-processor-variable',
    props: [],
    mounted () {
      this.getVariables();
    },
    data () {
      return {
        variables: [],
        editVar: null,
        bt_variable: '',
        bank_processor_name: '',
        payment_processor: null
      }
    },
    methods: {
      limpiar(){
        this.editVar = null;
        this.bt_variable = null;
        this.bank_processor_name = null;
        this.payment_processor = null;
      },
      getVariables(){
        axios.get( '/api/accounting/bt_variables').then(response => {
          this.variables = response.data.data;
        });
      },
      guardarVar(){
        Vue.toasted.show('Guardando Variable...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/bt_variables/save', {
          'bt_variable_id': this.editVar === 'New' ? -1 : this.editVar,
          'bt_variable': this.bt_variable,
          'bank_processor_name': this.bank_processor_name,
          'payment_processor': this.payment_processor,
        }).then(response => {
          this.limpiar();
          this.getVariables();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Variable guardada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });

      },
      editarVar(variable){
        this.editVar = variable.id;
        this.bt_variable = variable.bt_variable;
        this.bank_processor_name = variable.bank_processor_name;
        this.payment_processor = variable.payment_processor;
      },
      borrarVar(vid){
        Vue.toasted.show('Borrando Variable...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/bt_variables/delete', {
          'bt_variable_id': vid,
        }).then(response => {
          this.getVariables();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Variable borrada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },

    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-views-admin-accounting-payment-processor-variable {

  }
</style>
